module.exports = __webpack_public_path__ + "static/gallery32-26052e9120f9b61a55871db2c9932f4c.jpg";